import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let treatment_card_id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'treatment_card_id',
  })
  return {
    variables: { treatment_card_id },
    pause: !treatment_card_id,
  }
}
